<template>
  <div class="container-fluid">
    <h4 class="m-3">Детальная карточка товара</h4>
    <el-form
      ref="form"
      label-width="250px"
      label-position="left"
      id="uploadForm"
      name="uploadForm"
    >
      <el-form-item label="Название">
        <el-input v-model="product.title" disabled></el-input>
      </el-form-item>
      <el-form-item label="Описание">
        <el-input
          type="textarea"
          :rows="3"
          v-model="product.description"
          disabled
        ></el-input>
      </el-form-item>
      <el-form-item label="Артикул">
        <el-input v-model="product.article" disabled></el-input>
      </el-form-item>
      <el-form-item label="Производитель">
        <el-input v-model="product.makerTitle" disabled></el-input>
      </el-form-item>
      <el-form-item label-width="250px" label="Добавить в рекомендуемые?">
        <el-radio v-model="product.recommended" :label="true">Да</el-radio>
        <el-radio v-model="product.recommended" :label="false">Нет</el-radio>
      </el-form-item>
      <el-form-item label-width="250px" label="Хит">
        <el-tag v-if="product.hit">Да</el-tag>
        <el-tag v-else>Нет</el-tag>
        <!-- <el-radio v-model="product.hit" :label="true" disabled>Да</el-radio>
        <el-radio v-model="product.hit" :label="false" disabled>Нет</el-radio> -->
      </el-form-item>
      <el-form-item label-width="250px" label="Новинка">
        <el-tag v-if="product.new">Да</el-tag>
        <el-tag v-else>Нет</el-tag>
        <!-- <el-radio v-model="product.new" :label="true" disabled>Да</el-radio>
        <el-radio v-model="product.new" :label="false" disabled>Нет</el-radio> -->
      </el-form-item>
      <el-form-item label="Активность">
        <el-checkbox v-model="product.activity"></el-checkbox>
      </el-form-item>
      <!-- <el-form-item label-width="250px" label="Действует скидка по дисконтным картам?">
                <el-radio v-model="product.discount_work" :label="true">Да</el-radio>
                <el-radio v-model="product.discount_work" :label="false">Нет</el-radio>
            </el-form-item> -->
      <hr />
      <h6>Единица измерения</h6>
      <el-form-item label="Название">
        <el-input v-model="product.unitTitle" disabled></el-input>
      </el-form-item>
      <el-form-item label="Короткое название">
        <el-input v-model="product.unitShort" disabled></el-input>
      </el-form-item>
      <el-form-item label="Винительный падеж">
        <el-input v-model="product.unitAccCase" disabled></el-input>
      </el-form-item>
      <hr />
      <el-form-item label="Сортировка">
        <el-input v-model="product.sort"></el-input>
      </el-form-item>
      <el-form-item label="Раздел каталога">
        <el-input v-model="product.sectionPath" disabled></el-input>
      </el-form-item>
      <el-form-item label="Изображения">
        <el-upload
          action=""
          list-type="picture"
          :file-list="fileList"
          :limit="1"
          :auto-upload="false"
          :disabled="isDisableFileList"
          :on-remove="handleRemoveImage"
        >
          <!-- <el-button disabled size="small" type="primary">Добавить Изображение</el-button> -->
        </el-upload>
      </el-form-item>
      <el-form-item label="Предложение">
        <product-skus :item="product.sku"></product-skus>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="update">Изменить</el-button>
        <el-button @click="back">Отмена</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import axios from "axios";
import getFileList from "../../composable/utils/getFileList";
import getErrors, { getTextErrors } from "../../composable/utils/getErrors";
import ProductSkus from "@/components/ProductSkus/ProductSkus";
import useFormData from "../../composable/useFormData";

export default {
  name: "ProductUpdate",
  components: { ProductSkus },
  data() {
    return {
      product: {
        id: 0,
        sectionId: [],
        sectionPath: "",
        title: "",
        article: "",
        description: "",
        sort: 0,
        images: [],
        activity: false,
        new: false,
        recommended: false,
        hit: false,
        makerTitle: "",
        unitTitle: "",
        unitStep: "",
        unitAccCase: "",
        unitShort: "",
        sku: {},
      },
      isDisableFileList: false,
      fileList: [],
      errors: [],
    };
  },
  mounted() {
    this.getProduct();
  },

  methods: {
    back() {
      this.$router.go(-1);
    },
    getProduct: function() {
      axios
        .get("/product/" + this.$route.params.id)
        .then((response) => {
          this.initProduct(response.data);
          this.setFileList(this.product.images);
        })
        .catch((errors) => {
          if (errors.response.status === 401) {
            this.$router.push("/login");
          }
          if (errors.response.status === 422) {
            this.setErrors(errors.response.data.errors);
          }
        });
    },

    update() {
      const { execute } = useFormData();

      const data = execute()
        .setFields(["activity", "sort", "recommended"])
        .getFormData(this.product);

      axios
        .post("product/" + this.product.id, data)
        .then((response) => {
          if (response.status === 200) {
            this.back();
          }
        })
        .catch((errors) => {
          if (errors.response.status === 401) {
            this.$router.push("/login");
          }
          if (errors.response.status === 422) {
            this.setErrors(errors.response.data.errors);
            this.$notify.error(getTextErrors(this.errors));
          }
        });
    },

    setFileList(value) {
      this.fileList = getFileList(value);
      if (this.fileList.length == 1 && this.fileList.at(0).id == null) {
        this.isDisableFileList = true;
      }
    },

    setErrors(err) {
      this.errors = getErrors(err);
    },

    handleRemoveImage(v) {
      if (v.id) {
        const imgItem = this.fileList.find((e) => e.id == v.id);
        if (imgItem) {
          this.removeImage(this.product.id, v.id);
        }
      }
    },

    initProduct(value) {
      if (value) {
        this.product.id = value.id || 0;
        this.product.title = value.title || "";
        this.product.article = value.article || "";
        this.product.description = value.description || "";
        this.product.makerTitle = value.maker?.title || "";
        this.product.sort = value.sort || 0;
        this.product.activity = value.activity || false;
        this.product.new = value.new || false;
        this.product.recommended = value.recommended || false;
        this.product.hit = value.hit || false;
        this.product.unitTitle = value?.unit?.title || "";
        this.product.unitStep = value?.unit?.step || 0;
        this.product.unitAccCase = value?.unit?.acc_case || "";
        this.product.unitShort = value.unit?.short || "";
        this.product.images = value.img || [];
        this.product.sku = value.productSku || {};
        this.product.sectionId = value.section?.length
          ? value.section.map((e) => e.id)
          : [value.section?.id] || [0];
        this.product.sectionPath = value.section?.path || "";
      }
    },

    removeImage: async function(productId, imageId) {
      axios
        .post(`product/${productId}/image-delete`, {
          image_id: imageId,
        })
        .catch((errors) => {
          if (errors.response.status === 401) {
            this.$router.push("/login");
          }
          this.$notify.error("Ошибка при удалении");
        });
    },
  },
};
</script>

<style scoped></style>
